// extracted by mini-css-extract-plugin
export default {"input":"style_input__oOIbr","text":"style_text__QRAfr"};